import { unstable_createBreakpoints } from '@mui/material';

export const breakpoints = unstable_createBreakpoints({
  values: {
    xs: 0,
    sm: 576,
    md: 900,
    lg: 1200,
    xl: 1440,
  },
});
